const tableRangeRegex = /^(.+)\[(.+)\]$/u;

export class TableRangeAddress {
  tableName = '';
  partName='';
  isValid: boolean = true;

  static fromString(addressStr: string) {
    const result = tableRangeRegex.exec(addressStr);
    if (!result) {
      const address = new TableRangeAddress();
      address.isValid = false;
      return address;
    }

    const address = new TableRangeAddress();
    address.tableName = result[1];
    address.partName = result[2];
    return address;
  }

  toString() {
    return `${this.tableName}[${this.partName}]`;
  }
}
